module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Wyświetlaj nazwę",
      "error": _vm.errors['display_name']
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form['display_name']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'display_name', $$v)
      },
      expression: "form['display_name']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nazwa widgetu"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a7d83ef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/BaseWidget.vue
// module id = 719
// module chunks = 0